module.exports = __webpack_public_path__ + "img/logo_white.7f310c12.png";